import { __extends } from "tslib";
import React from 'react';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, _a) {
        var componentStack = _a.componentStack;
        var errorToPass = new Error(error.message);
        errorToPass.stack = componentStack;
        var detail = {
            error: errorToPass,
            dsn: this.props.sentryConfig.sentryDsn,
            environment: this.props.sentryConfig.environment,
            release: this.props.sentryConfig.release,
        };
        var errorEvent = new CustomEvent('on-spa-error', { detail: detail });
        window.dispatchEvent(errorEvent);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback || React.createElement("h1", null, "Something went wrong.");
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
